import { render, staticRenderFns } from "./updatapass.vue?vue&type=template&id=5e82a2f0&scoped=true&"
import script from "./updatapass.vue?vue&type=script&lang=js&"
export * from "./updatapass.vue?vue&type=script&lang=js&"
import style0 from "./updatapass.vue?vue&type=style&index=0&id=5e82a2f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e82a2f0",
  null
  
)

export default component.exports